export default __webpack_public_path__ + "static/media/vid-1.cf090ae1.mp4";